import React, { useCallback } from 'react';
import { Excalidraw, AppState, ExcalidrawElement } from '@excalidraw/excalidraw';
import { useTheme } from 'next-themes';
export interface ExcalidrawData {
  elements: readonly ExcalidrawElement[];
  appState?: Partial<AppState>;
}

interface ExcalidrawCanvasProps {
  initialData?: ExcalidrawData | null;
  readOnly?: boolean;
  onChange?: (data: ExcalidrawData) => void;
  className?: string;
}

const ExcalidrawCanvas: React.FC<ExcalidrawCanvasProps> = ({
  initialData,
  readOnly = false,
  onChange,
  className,
}) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const handleChange = useCallback(
    (elements: readonly ExcalidrawElement[], appState: AppState) => {
      if (!onChange) return;
      onChange({ elements: [...elements], appState });
    },
    [onChange]
  );

  return (
    <div className={className ?? 'border rounded-md overflow-hidden h-[600px] bg-background'}>
      <Excalidraw
        initialData={initialData ?? undefined}
        viewModeEnabled={readOnly}
        theme={isDark ? 'dark' : 'light'}
        onChange={handleChange}
      />
    </div>
  );
};

export default ExcalidrawCanvas;


